<template>
  <div class="container-grid grid-3 grid-md-1 mb-md-10">
    <div v-for="item in items" :key="item.title" class="container-grid__item">
      <div>
        <span class="text-danger content_35" v-html="item.title"></span>
        <hr/>
        <p class="content_18" v-html="item.text"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Grid3Underline",
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>